import React from 'react'
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {findNestedValue} from 'ag-common/tools/objects'
import Box from '#components/a/Box'

export class ControllableTabs extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      defaultIndex: 0,
      chapterId: this.props.chapterId,
    }
  }

  handleSelect(tabIndex) {
    this.setState({chapterId: this.props.chapterId})
    this.props.onSelectTab(tabIndex)
  }

  getModifier(chapterId, questionId, isWrong) {
    const answer = findNestedValue(this.props.answers, [chapterId, questionId])
    let modifier = 'default'
    if (answer !== undefined) {
      modifier = 'draft'
      if ((answer.kommentar !== undefined && answer.kommentar.text && answer.kommentar.text.length > 0) && this.props.canViewComment) {
        modifier += ' message'
      }
      if (answer.done) {
        modifier += ' done'
      }
    }
    if (isWrong) {
      modifier = 'error'
    }
    return modifier
  }

  getTabTitles = () => {
    const {tabz} = this.props
    const tabs = tabz.map((tab, index) => {
      const {chapterId} = tab[1].props
      const questionId = tab[1].props.question.id
      const questionIsWrong = tab[1].props.isWrong
      const modifier = this.getModifier(chapterId, questionId, questionIsWrong)
      return (
        <Tab key={index.toString()}>
          <div className={modifier}>
            <span>{tab[0]}</span>
          </div>
        </Tab>
      )
    })
    return tabs
  }

  getClassName = () => {
    let classname = 'tabz'
    if (this.props.type === 'numbers') {
      classname += ' tabz--numbers'
    }
    return classname
  }

  getTabContent = () =>
    this.props.tabz.map((tab, index) => {
      const tabContent = tab[1]
      const comment = tab[2]
      if (tabContent) {
        return (
          <TabPanel key={index.toString()}>
            <Box>{tabContent}</Box>
            {comment}
          </TabPanel>
        )
      }
      return <TabPanel key={index.toString()} />
    })

  render() {
    return (
      <div className={this.getClassName()}>
        <Tabs
          onSelect={tabIndex => this.handleSelect(tabIndex)}
          selectedIndex={this.props.selectedTab}
        >
          <TabList>{this.getTabTitles()}</TabList>
          {this.getTabContent()}
        </Tabs>
      </div>
    )
  }
}

ControllableTabs.propTypes = {
  selectedTab: PropTypes.number,
  onSelectTab: PropTypes.func.isRequired,
  tabz: PropTypes.array,
  type: PropTypes.string,
  answers: PropTypes.object.isRequired,
  chapterId: PropTypes.string,
  canViewComment: PropTypes.bool,
}

const mapStateToProps = state => {
  const {answers} = state.ausbildungsplan
  return {answers}
}

export default connect(mapStateToProps)(ControllableTabs)
